import React from 'react';
import { Link } from 'react-router-dom'

// Icons
import Icons from './icons';
import AccountStatus from './AccountStatus';

const ChallengeCard = ({ col = "col-12", to, className, imgSrc, name, type, step, status, trades, size, days, statusClass, CredentialsClick, BoxClick }) => {
  return (
    <div className={col}>
      <div className={`challenge-card-bx ${className}`}>
        <div className="ccb-inner" onClick={BoxClick}>

          <div className="ccd-ss-bx">
            <div className="ccb-step">{step}</div>
            <AccountStatus className={statusClass} statusText={status} />
          </div>

          <div className="challenge-top-bx">
            <div className="ccb-info-bx">
              <div className="ccb-i-img"><img src={imgSrc} alt='' /></div>
              <div className="ccb-i-data">
                <div className="ccb-i-name">{name}</div>
                <div className="ccb-i-type">{type}</div>
              </div>
            </div>
          </div>

          {/* <div className="challenge-account-size">
            <div className="cas-heading">Account size</div>
            <div className="cas-data">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.896 7.4462C15.9455 7.39056 15.9702 7.36274 15.9693 7.32966C15.9683 7.29659 15.942 7.27027 15.8893 7.21763L15.087 6.41528L15.0745 6.40281C15.0275 6.35615 14.9385 6.2676 14.8716 6.17872C14.8184 6.10801 14.5379 5.72888 14.7377 5.24639C14.9376 4.76389 15.4041 4.69418 15.4917 4.68179C15.6018 4.66622 15.7274 4.66658 15.7936 4.66676L17.1526 4.66679C17.5145 4.66672 17.8663 4.66665 18.1564 4.70566C18.4835 4.74963 18.8567 4.85677 19.1668 5.16679C19.4768 5.4768 19.5839 5.85003 19.6279 6.1771C19.6669 6.46721 19.6668 6.81895 19.6667 7.18088L19.6668 8.53999C19.667 8.60616 19.6673 8.73176 19.6517 8.84188C19.6394 8.92949 19.5696 9.39595 19.0872 9.5958C18.6047 9.79566 18.2255 9.51512 18.1548 9.46193C18.0659 9.39507 17.9774 9.30601 17.9307 9.25909L17.9183 9.24657L17.306 8.63429C17.2474 8.57567 17.2181 8.54636 17.1821 8.54742C17.1462 8.54848 17.1186 8.57945 17.0636 8.64141L12.9785 13.2371C12.755 13.4886 12.5366 13.7344 12.3286 13.9144C12.0935 14.1178 11.7871 14.3143 11.3773 14.3491C10.9675 14.3839 10.6323 14.2419 10.3662 14.081C10.1309 13.9387 9.87422 13.7333 9.6115 13.523L7.8111 12.0827C7.71132 12.0028 7.61212 11.9196 7.51012 11.8403C7.38793 11.7453 7.32684 11.6978 7.23345 11.703C7.14005 11.7082 7.08458 11.7621 6.97364 11.87C6.88101 11.9601 6.79162 12.0538 6.70127 12.1441L2.75609 16.0893C2.43065 16.4148 1.90301 16.4148 1.57757 16.0893C1.25214 15.7639 1.25214 15.2362 1.57757 14.9108L5.5524 10.936C5.77741 10.7109 5.99856 10.4896 6.20668 10.3288C6.4427 10.1464 6.74443 9.97432 7.13651 9.95261C7.52859 9.93089 7.84748 10.0686 8.10219 10.2238C8.32679 10.3607 8.57102 10.5561 8.81951 10.755L10.6185 12.1942C10.7242 12.2788 10.8293 12.3671 10.9375 12.4511C11.0664 12.5512 11.1308 12.6013 11.2282 12.593C11.3255 12.5847 11.3806 12.5245 11.4908 12.4042C11.5832 12.3031 11.6719 12.1983 11.7619 12.0971L15.896 7.4462Z" fill="#B4B8C9" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.8335 7.16668C3.8335 6.70644 4.20659 6.33334 4.66683 6.33334H9.66683C10.1271 6.33334 10.5002 6.70644 10.5002 7.16668C10.5002 7.62691 10.1271 8.00001 9.66683 8.00001H4.66683C4.20659 8.00001 3.8335 7.62691 3.8335 7.16668Z" fill="#B4B8C9" />
              </svg>
              $5000
            </div>
          </div> */}

          <div className="challenge-trade-info">
            <div className="cti-item">
              <div className="cti-icon">

                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.4995 4.16682C10.0369 3.51598 9.43186 3.00015 8.48863 3.00015C4.23356 3.00015 6.4592 10.2502 2.49951 10.2502" stroke="#85FF67" stroke-width="0.75" stroke-linecap="round" />
                  <path d="M10.5 10.5H5C3.35008 10.5 2.52513 10.5 2.01256 9.98744C1.5 9.47487 1.5 8.64992 1.5 7V1.5" stroke="#85FF67" stroke-width="0.75" stroke-linecap="round" />
                </svg>

              </div>
              <div className="cti-data-bx">
                <div className="cti-label">No. of trades</div>
                <div className="cti-num">{trades} times</div>
              </div>
            </div>

            <div className="cti-item">
              <div className="cti-icon">

                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1_7010)">
                    <path d="M9.24902 4.22694L10.7301 4.22694C9.83046 1.85245 7.24752 0.500018 4.72922 1.17243C2.04702 1.88861 0.453839 4.6306 1.17076 7.29682C1.88768 9.96305 4.64322 11.5439 7.32543 10.8277C9.31693 10.2959 10.7081 8.64739 10.999 6.74225" stroke="#85FF67" stroke-width="0.75" stroke-linejoin="round" />
                    <path d="M5.99951 3.49991V5.99991L7.24951 7.24991" stroke="#85FF67" stroke-width="0.75" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_7010">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

              </div>
              <div className="cti-data-bx">
                <div className="cti-label">Days traded</div>
                <div className="cti-num">{days} days</div>
              </div>
            </div>
          </div>
        </div>
        <div className="challenge-btns">
          <div className="common-btn cb-outline" onClick={CredentialsClick}><span>Credentials</span></div>
          <Link to={to} className="common-btn cb-fill"><span>Dashboard</span></Link>
        </div>
      </div>
    </div>
  );
};

export default ChallengeCard;
